import { render, staticRenderFns } from "./BasicSearcher.vue?vue&type=template&id=402d8832&"
import script from "./BasicSearcher.vue?vue&type=script&lang=js&"
export * from "./BasicSearcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports